import Base from './base'

export default {
  get (id, token) {
    return Base
      .get(`view_customer/id/${id}`, { headers: {Authorization: `Bearer ${token}`} })
      .then(res => res.data)
  }
}
